import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
import { Heading, Hr } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import AppointmentOverviewContainer from "../../../../../../../../../components/AppointmentOverview/v3/components/AppointmentOverview/AppointmentOverviewContainer.js";
/* empty css                                   */
const CancelAppointmentConfirmation = ({
  appointment,
  store,
  labels,
  returnPath,
  returnLabel,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("cancel-appointment-confirmation", className) }, /* @__PURE__ */ React.createElement(Heading, { component: "h3", variant: "small", className: "cancel-appointment-confirmation__title" }, labels.title), /* @__PURE__ */ React.createElement(Hr, null), /* @__PURE__ */ React.createElement(Alert, { variant: "success", className: "alert-m-default cancel-appointment-confirmation__alert" }, labels.notification), /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", className: "" }, labels.subtitle), /* @__PURE__ */ React.createElement(
  AppointmentOverviewContainer,
  {
    className: "cancel-appointment-confirmation__overview",
    appointment,
    store,
    isStoreLoading: false
  }
), /* @__PURE__ */ React.createElement(
  Button,
  {
    variant: "outline",
    className: "cancel-appointment-confirmation__button",
    caption: returnLabel,
    href: returnPath
  }
));
export {
  CancelAppointmentConfirmation as default
};
//# sourceMappingURL=CancelAppointmentConfirmation.js.map
